module.exports = __webpack_public_path__ + "img/icon_bg2.d2b8a549.png";